import { render, staticRenderFns } from "./CustomCheckboxOff.vue?vue&type=template&id=6062e786&"
import script from "./CustomCheckboxOff.vue?vue&type=script&lang=ts&"
export * from "./CustomCheckboxOff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports